import { render, staticRenderFns } from "./CommentUserProfileContent.vue?vue&type=template&id=0dd8b776"
import script from "./CommentUserProfileContent.vue?vue&type=script&lang=js"
export * from "./CommentUserProfileContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports